import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Shell } from '../../components/layout/Shell';
import { api } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Receipt, ArrowUpRight } from '@phosphor-icons/react';

const EmployerBilling = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/billing/me').then((r) => setData(r.data));
  }, []);

  if (!data) return <Shell><div className="p-8 mono text-sm">Loading...</div></Shell>;

  return (
    <Shell>
      <div className="max-w-[1000px] mx-auto px-6 py-10">
        <div className="label-eyebrow text-primary mb-2">BILLING</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Your plan, in plain terms.</h1>

        <div className="grid md:grid-cols-2 gap-0 grid-skeleton" data-testid="billing-card">
          <div className="p-8 bg-white">
            <div className="flex items-center gap-2 mb-4">
              <Receipt size={20} weight="duotone" className="text-primary" />
              <div className="label-eyebrow">CURRENT PLAN</div>
            </div>
            <div className="mono font-black text-5xl mb-3">{data.plan_details?.label || data.plan}</div>
            <div className="mono text-sm text-muted-foreground mb-4">
              ${data.plan_details?.amount ?? 0} / month
            </div>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between"><span className="text-muted-foreground">Seats</span><span className="mono font-bold">{data.plan_details?.seats}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Active jobs</span><span className="mono font-bold">{data.plan_details?.jobs_limit}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Status</span><span className={`label-eyebrow ${data.is_active ? 'text-primary' : 'text-destructive'}`}>{data.is_active ? 'ACTIVE' : 'EXPIRED'}</span></div>
              {data.active_until && (
                <div className="flex justify-between"><span className="text-muted-foreground">Renews / expires</span><span className="mono text-xs">{new Date(data.active_until).toLocaleDateString()}</span></div>
              )}
            </div>
          </div>

          <div className="p-8 bg-white">
            <div className="label-eyebrow text-muted-foreground mb-3">UPGRADE OR CHANGE</div>
            <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
              Move to Team or Scale to unlock AI explanations, work-style profiles, fairness audit,
              and ML anti-gaming. All pricing is clear, no hidden fees.
            </p>
            <Link to="/pricing">
              <Button className="rounded-none" data-testid="billing-view-plans">
                View all plans <ArrowUpRight size={16} className="ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Shell>
  );
};

export default EmployerBilling;
